import { render, staticRenderFns } from "./user_navleft.vue?vue&type=template&id=084a33e4&scoped=true"
import script from "./user_navleft.vue?vue&type=script&lang=js"
export * from "./user_navleft.vue?vue&type=script&lang=js"
import style0 from "./user_navleft.vue?vue&type=style&index=0&id=084a33e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084a33e4",
  null
  
)

export default component.exports